<mib-tabs
  class="min-w-0 flex-1"
  subLabels="panel"
  closeLabel="Close the case"
  loadingLabel="Loading the case"
  label="Open cases"
  overflowLabel="Open cases"
  [behaviour]="behaviour()"
  [tabs]="tabs()"
  [selected]="reading()"
  (selectedChange)="open($event)"
  (closed)="close($event)"></mib-tabs>
